import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import * as bootstrap from 'bootstrap'
import "../../scss/application.scss";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
//import "/node_modules/flag-icons/css/flag-icons.min.css";
//import 'swiper/css';
//import 'swiper/css/navigation';

const reactAppRoot = document.getElementById('react-root-fondazionepielle');

if (reactAppRoot) {
    ReactDOM.createRoot(reactAppRoot).render(
        <App />
        //<React.StrictMode>
        //    <App />
        //</React.StrictMode>,
    )
}
 